import React from "react"
import SiteWrapper from "@components/structure/SiteWrapper/SiteWrapper"
import * as styles from "./InformationPage.module.scss"

const InformationPage = ({title, body}) => (
  <section className={styles.InformationPage}>
    <SiteWrapper narrow>
      <h1 className={styles.pageTitle}>{title}</h1>
      <div className={styles.pageBody} dangerouslySetInnerHTML={{ __html: body }} />
    </SiteWrapper>
  </section>
)

export default InformationPage
